import React from 'react';

import {NoResultPage} from 'src/modules/entitlements';

import {
    NO_PRESETS_DESCRIPTION,
    NO_PRESETS_TITLE,
} from '../constants';

import type {ResourceView} from 'src/modules/entitlements/typedef';
import type {PresetRelationItem} from 'src/openapi/admin/models/PresetRelationItem';

type Props = {
    result: {data: {view: ResourceView[], relations: PresetRelationItem[]}, totalCount: number} | null,
};

export const NoResultMessage = ({result}: Props) => {
    if (result && !result.data.view.length) {
        return (
            <NoResultPage
                title={NO_PRESETS_TITLE}
                description={NO_PRESETS_DESCRIPTION}
            />
        );
    }

    return <div/>;
};
